module.exports = __webpack_public_path__ + "static/media/receivedIcon.4ec37bec.svg";